<template>
  <figure>
    <button
      class="relative block aspect-video w-full overflow-hidden rounded"
      @click="isOpen = true"
    >
      <img
        :src="albumImageUrl"
        :alt="albumName"
        loading="lazy"
        class="pointer-events-none absolute left-0 top-0 block h-full w-full object-cover"
      />
    </button>

    <slot />

    <Teleport to="body" :disabled="!isOpen">
      <Transition name="modal">
        <div
          v-if="isOpen"
          class="fixed left-0 top-0 z-lightbox flex h-full w-full items-center justify-center bg-black/60 px-2.5"
          @click.stop="isOpen = false"
        >
          <img
            :src="albumImageUrl"
            :alt="albumName"
            loading="lazy"
            class="max-w-[calc(100%-20px) pointer-events-none block max-h-[calc(100%-40px)]"
            @click.stop=""
          />
        </div>
      </Transition>
    </Teleport>
  </figure>
</template>

<script setup lang="ts">
  interface IProps {
    albumName?: string;
    albumImageUrl: string;
  }

  withDefaults(defineProps<IProps>(), {
    albumName: '',
  });

  const mainStore = useMainStore();

  const isOpen = ref<boolean>(false);

  watch(isOpen, (value: boolean) => {
    mainStore.isBodyFixed = value;
  });

  onBeforeUnmount(() => {
    mainStore.isBodyFixed = false;
  });
</script>
